import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Form } from 'react-final-form';

import FormField from 'components/Form/FormField';
import {
  required,
  composeValidators,
  isEmail,
  isPhone,
  validateIfValue,
} from 'utils/formValidators';
import BusinessApi from 'apis/Business';
import Toaster from 'components/Toaster';
import { camelKeysToSnakeCaseKeys } from 'utils/caseConvertors';
import BusinessCardWrapper from '../businessCardWrapper';

const ConditionalField = ({
  isEditing,
  value,
  label,
  name,
  validate,
  placeholder,
}) => {
  if (isEditing) {
    return (
      <FormField
        label={label}
        name={name}
        placeholder={placeholder}
        containerClassName="row input-group-sm pr-md-3"
        labelClassName="col-md-4 row-title"
        inputClassName="form-control col-md-8"
        validate={validate}
      />
    );
  }

  return (
    <div className="row">
      <div className="col-md-4 row-title">{label}</div>
      <div className="col-md-8">{value}</div>
    </div>
  );
};

const ContactInfo = ({ match, contact, fetchBusinessDetail }) => {
  const [isEditing, setIsEditing] = useState(false);
  const {
    first_name: firstName,
    last_name: lastName,
    email,
    primary_number: primaryNumber,
  } = contact || {};

  const initialValues = {
    firstName,
    lastName,
    email,
    primaryNumber,
  };

  const onSubmit = async values => {
    const { params } = match;
    const { id } = params;
    const contactAttributes = camelKeysToSnakeCaseKeys(values);
    const data = {
      business: { contact_attributes: contactAttributes },
    };
    BusinessApi.update(id, data)
      .then(() => {
        setIsEditing(false);
        Toaster.getSuccessToaster(
          'check-circle',
          'Successfully updated contact details'
        );
        fetchBusinessDetail();
      })
      .catch(() =>
        Toaster.getErrorToaster(
          'exclamation-triangle',
          'Failed to update contact details'
        )
      );
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      render={({ handleSubmit, form, submitting }) => (
        <form name="customSurveyEditForm" onSubmit={handleSubmit}>
          <BusinessCardWrapper
            iconLeft="user"
            title="Primary Contact"
            iconRight="pencil-alt"
            confirmIcon="check"
            cancelIcon="times"
            isEditing={isEditing}
            submitting={submitting}
            onEdit={() => setIsEditing(true)}
            onConfirm={handleSubmit}
            onCancel={() => {
              setIsEditing(false);
              form.reset();
            }}
          >
            <div className="p-3">
              <ConditionalField
                isEditing={isEditing}
                name="firstName"
                label="First Name:"
                placeholder="First Name"
                value={firstName}
              />
              <hr />
              <ConditionalField
                isEditing={isEditing}
                name="lastName"
                label="Last Name:"
                placeholder="Last Name"
                value={lastName}
              />
              <hr />
              <ConditionalField
                isEditing={isEditing}
                name="email"
                label="Email Address:"
                placeholder="Email Address"
                value={email}
                validate={validateIfValue(isEmail)}
              />
              <hr />
              <ConditionalField
                isEditing={isEditing}
                name="primaryNumber"
                label="Phone Number:"
                placeholder="Phone Number"
                value={primaryNumber}
                validate={validateIfValue(isPhone)}
              />
            </div>
          </BusinessCardWrapper>
        </form>
      )}
    />
  );
};

ContactInfo.defaultProps = {
  contact: {
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
  },
};

ContactInfo.propTypes = {
  contact: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
    phone_number: PropTypes.string,
  }),
  fetchBusinessDetails: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(ContactInfo);



// WEBPACK FOOTER //
// ./src/components/businessDetail/primaryContact/contactInfo.js